export const API_CONFIG = {
  baseURL:
    (window as any).LUMIVIX_API_URL ||
    (typeof window !== 'undefined' && window.location.hostname === 'localhost' && process.env.NODE_ENV === 'development'
      ? 'http://localhost:8043'
      : '/lumi-api'),
  endpoints: {
    login: '/auth/login',
    register: '/auth/register',
  },
};

export default API_CONFIG;

